import { render, staticRenderFns } from "./ThemeSettingsDirectTopTef2.vue?vue&type=template&id=6eafd7ce&scoped=true"
import script from "./ThemeSettingsDirectTopTef2.vue?vue&type=script&lang=js"
export * from "./ThemeSettingsDirectTopTef2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eafd7ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6eafd7ce')) {
      api.createRecord('6eafd7ce', component.options)
    } else {
      api.reload('6eafd7ce', component.options)
    }
    module.hot.accept("./ThemeSettingsDirectTopTef2.vue?vue&type=template&id=6eafd7ce&scoped=true", function () {
      api.rerender('6eafd7ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/projects/themes/ThemeSettingsDirectTopTef2.vue"
export default component.exports